import LocationPayload from 'APP/main/ChatView/Messages/Message/Payload/Location';

const Location = ({ message }) => {
  return (
    <LocationPayload
      message={message}
      hasBubble={false}
    />
  );
};

export default Location;
